import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
import { Button, Row, Col, Label, Input, Form } from "reactstrap";
import Swal from "sweetalert2";
import axios from "axios";
import moment from "moment";
import CurrencyInput from "react-currency-input-field";

// Captura manual de movimientos bancarios: Ingreso / Egreso / Traspaso.
// - Ingreso/Egreso: un MovimientosBancos con los datos descriptivos.
// - Traspaso: un BancosTraspasos + 2 movimientos (Egreso en origen, Ingreso en destino).
function MovimientosBancosCreate() {
  const { user } = useContext(AuthContext);
  const URL_BANCOS = process.env.REACT_APP_URL_BANCOS;
  const URL_MOVIMIENTOS_BANCOS = process.env.REACT_APP_URL_MOVIMIENTOS_BANCOS;
  const URL_BANCOS_TRASPASOS = process.env.REACT_APP_URL_BANCOS_TRASPASOS;
  const URL_CATEGORIAS = process.env.REACT_APP_URL_CATEGORIAS;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;

  const hoy = moment(new Date()).format("YYYY-MM-DD");

  const [tipo, setTipo] = useState("Ingreso"); // Ingreso | Egreso | Traspaso
  const [fecha, setFecha] = useState(hoy);
  const [bancos, setBancos] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [proveedores, setProveedores] = useState([]);

  // Ingreso / Egreso
  const [selectedBanco, setSelectedBanco] = useState("");
  const [monto, setMonto] = useState(0);
  const [concepto, setConcepto] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [selectedCategoria, setSelectedCategoria] = useState("");
  const [selectedProveedor, setSelectedProveedor] = useState("");
  const [notas, setNotas] = useState("");

  // Traspaso
  const [bancoOrigen, setBancoOrigen] = useState("");
  const [bancoDestino, setBancoDestino] = useState("");
  const [monedaOrigen, setMonedaOrigen] = useState("MXN");
  const [monedaDestino, setMonedaDestino] = useState("MXN");
  const [tipoCambio, setTipoCambio] = useState(1);
  const [importeDestino, setImporteDestino] = useState(0);

  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };
    axios
      .get(URL_BANCOS, { headers })
      .then((res) =>
        setBancos((res.data || []).filter((b) => b.is_active !== "No"))
      )
      .catch((err) => console.log(err));
    axios
      .get(URL_CATEGORIAS, { headers })
      .then((res) => setCategorias(res.data || []))
      .catch((err) => console.log(err));
    axios
      .get(URL_PROVEEDORES, { headers })
      .then((res) => setProveedores(res.data || []))
      .catch((err) => console.log(err));
  }, []);

  const monedaDe = (idBanco) => {
    const b = bancos.find((x) => x._id === idBanco);
    return b ? b.moneda : "MXN";
  };

  const handleOrigen = (id) => {
    setBancoOrigen(id);
    setMonedaOrigen(monedaDe(id));
  };
  const handleDestino = (id) => {
    setBancoDestino(id);
    setMonedaDestino(monedaDe(id));
  };

  const clear = () => {
    setMonto(0);
    setConcepto("");
    setDescripcion("");
    setSelectedCategoria("");
    setSelectedProveedor("");
    setNotas("");
    setImporteDestino(0);
    setTipoCambio(1);
  };

  const guardar = (event) => {
    event.preventDefault();
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };

    // ---- TRASPASO ----
    if (tipo === "Traspaso") {
      if (!bancoOrigen || !bancoDestino) {
        Swal.fire({ icon: "error", title: "Selecciona origen y destino" });
        return;
      }
      if (bancoOrigen === bancoDestino) {
        Swal.fire({ icon: "error", title: "Origen y destino deben ser distintos" });
        return;
      }
      const m = Number(monto) || 0;
      if (m <= 0) {
        Swal.fire({ icon: "error", title: "Captura un importe" });
        return;
      }
      // importe en destino (por si hay cambio de moneda)
      let destino = m;
      if (monedaOrigen === "MXN" && monedaDestino === "USD")
        destino = Number((m / (Number(tipoCambio) || 1)).toFixed(2));
      else if (monedaOrigen === "USD" && monedaDestino === "MXN")
        destino = Number((m * (Number(tipoCambio) || 1)).toFixed(2));

      setValidaBoton(false);
      axios
        .post(
          URL_BANCOS_TRASPASOS,
          {
            fecha,
            importe: m,
            bancoOrigen,
            bancoDestino,
            user: user.id,
            monedaOrigen,
            monedaDestino,
            tipoCambio: Number(tipoCambio) || 1,
          },
          { headers }
        )
        .then((data) => {
          const idTraspaso = data.data._id;
          return Promise.all([
            // Egreso en el banco origen (importe negativo, como el resto del sistema)
            axios.post(
              URL_MOVIMIENTOS_BANCOS,
              {
                fecha,
                importe: -m,
                tipo: "Egreso",
                bancos: bancoOrigen,
                bancosTraspasos: idTraspaso,
                moneda: monedaOrigen,
                tipoCambio: 1,
              },
              { headers }
            ),
            // Ingreso en el banco destino
            axios.post(
              URL_MOVIMIENTOS_BANCOS,
              {
                fecha,
                importe: destino,
                tipo: "Ingreso",
                bancos: bancoDestino,
                bancosTraspasos: idTraspaso,
                moneda: monedaDestino,
                tipoCambio: 1,
              },
              { headers }
            ),
          ]);
        })
        .then(() => {
          axios.post(
            URL_LOGS,
            {
              tipo: "Traspaso Banco",
              detalle: `Fecha ${fecha} / Origen ${bancoOrigen} / Destino ${bancoDestino}`,
              user: user.id,
            },
            { headers }
          );
          Swal.fire("Good job!", "Traspaso registrado", "success");
          setTimeout(() => window.location.reload(), 1200);
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error?.response?.data || ""}`,
          });
          console.log(error);
          setValidaBoton(true);
        });
      return;
    }

    // ---- INGRESO / EGRESO ----
    if (!selectedBanco) {
      Swal.fire({ icon: "error", title: "Selecciona el banco" });
      return;
    }
    const m = Number(monto) || 0;
    if (m <= 0) {
      Swal.fire({ icon: "error", title: "Captura un importe" });
      return;
    }
    if (!concepto) {
      Swal.fire({ icon: "error", title: "Captura el concepto" });
      return;
    }
    setValidaBoton(false);
    // Egreso va con importe negativo (convención del sistema); Ingreso positivo.
    const importe = tipo === "Ingreso" ? m : -m;
    axios
      .post(
        URL_MOVIMIENTOS_BANCOS,
        {
          fecha,
          importe,
          tipo,
          bancos: selectedBanco,
          moneda: monedaDe(selectedBanco),
          tipoCambio: 1,
          concepto,
          descripcion: descripcion || "",
          categorias: selectedCategoria || null,
          proveedores: selectedProveedor || null,
          notas: notas || "",
        },
        { headers }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: `Movimiento Banco ${tipo}`,
            detalle: `${concepto} / ${m}`,
            user: user.id,
          },
          { headers }
        );
        clear();
        Swal.fire("Good job!", "Movimiento registrado", "success");
        setTimeout(() => window.location.reload(), 1200);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error?.response?.data || ""}`,
        });
        console.log(error);
        setValidaBoton(true);
      });
  };

  const esTraspaso = tipo === "Traspaso";

  return (
    <>
      <Header />
      <br />
      <br />
      {user.bancos ? (
        <div className="card container col-sm-8">
          <h3 align="center">Registrar Movimiento Bancario</h3>
          <Form onSubmit={guardar}>
            <Row>
              <Col md={4}>
                <Label className="mr-sm-2">Tipo</Label>
                <Input
                  type="select"
                  value={tipo}
                  onChange={(e) => setTipo(e.target.value)}
                >
                  <option value="Ingreso">Ingreso</option>
                  <option value="Egreso">Egreso</option>
                  <option value="Traspaso">Traspaso</option>
                </Input>
              </Col>
              <Col md={4}>
                <Label className="mr-sm-2">Fecha</Label>
                <Input
                  type="date"
                  value={fecha}
                  required
                  onChange={(e) => setFecha(e.target.value)}
                />
              </Col>
            </Row>

            {esTraspaso ? (
              <>
                <Row className="mt-2">
                  <Col md={6}>
                    <Label className="mr-sm-2">Banco Origen</Label>
                    <Input
                      type="select"
                      value={bancoOrigen}
                      onChange={(e) => handleOrigen(e.target.value)}
                    >
                      <option value="">Selecciona</option>
                      {bancos
                        .sort((a, b) => (a.banco > b.banco ? 1 : -1))
                        .map((b) => (
                          <option value={b._id}>
                            {b.banco} {b.cuenta} ({b.moneda})
                          </option>
                        ))}
                    </Input>
                  </Col>
                  <Col md={6}>
                    <Label className="mr-sm-2">Banco Destino</Label>
                    <Input
                      type="select"
                      value={bancoDestino}
                      onChange={(e) => handleDestino(e.target.value)}
                    >
                      <option value="">Selecciona</option>
                      {bancos
                        .filter((b) => b._id !== bancoOrigen)
                        .sort((a, b) => (a.banco > b.banco ? 1 : -1))
                        .map((b) => (
                          <option value={b._id}>
                            {b.banco} {b.cuenta} ({b.moneda})
                          </option>
                        ))}
                    </Input>
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col md={4}>
                    <Label className="mr-sm-2">Importe (Origen)</Label>
                    <CurrencyInput
                      intlConfig={{ locale: "en-US", currency: "USD" }}
                      prefix="$"
                      defaultValue={0}
                      decimalsLimit={2}
                      value={monto}
                      className="form-control"
                      onValueChange={(value) => {
                        setMonto(value || 0);
                        const v = Number(value) || 0;
                        if (monedaOrigen === "MXN" && monedaDestino === "USD")
                          setImporteDestino(
                            Number((v / (Number(tipoCambio) || 1)).toFixed(2))
                          );
                        else if (monedaOrigen === "USD" && monedaDestino === "MXN")
                          setImporteDestino(
                            Number((v * (Number(tipoCambio) || 1)).toFixed(2))
                          );
                        else setImporteDestino(v);
                      }}
                    />
                  </Col>
                  {monedaOrigen !== monedaDestino ? (
                    <>
                      <Col md={4}>
                        <Label className="mr-sm-2">Tipo de Cambio</Label>
                        <Input
                          type="number"
                          step="any"
                          value={tipoCambio}
                          onChange={(e) => {
                            setTipoCambio(e.target.value);
                            const v = Number(monto) || 0;
                            const tc = Number(e.target.value) || 1;
                            if (monedaOrigen === "MXN" && monedaDestino === "USD")
                              setImporteDestino(Number((v / tc).toFixed(2)));
                            else if (
                              monedaOrigen === "USD" &&
                              monedaDestino === "MXN"
                            )
                              setImporteDestino(Number((v * tc).toFixed(2)));
                          }}
                        />
                      </Col>
                      <Col md={4}>
                        <Label className="mr-sm-2">Importe (Destino)</Label>
                        <Input type="text" disabled value={`$${importeDestino}`} />
                      </Col>
                    </>
                  ) : null}
                </Row>
              </>
            ) : (
              <>
                <Row className="mt-2">
                  <Col md={6}>
                    <Label className="mr-sm-2">Banco / Cuenta</Label>
                    <Input
                      type="select"
                      value={selectedBanco}
                      onChange={(e) => setSelectedBanco(e.target.value)}
                    >
                      <option value="">Selecciona</option>
                      {bancos
                        .sort((a, b) => (a.banco > b.banco ? 1 : -1))
                        .map((b) => (
                          <option value={b._id}>
                            {b.banco} {b.cuenta} ({b.moneda})
                          </option>
                        ))}
                    </Input>
                  </Col>
                  <Col md={3}>
                    <Label className="mr-sm-2">Importe</Label>
                    <CurrencyInput
                      intlConfig={{ locale: "en-US", currency: "USD" }}
                      prefix="$"
                      defaultValue={0}
                      decimalsLimit={2}
                      value={monto}
                      className="form-control"
                      onValueChange={(value) => setMonto(value || 0)}
                    />
                  </Col>
                  <Col md={3}>
                    <Label className="mr-sm-2">Categoría</Label>
                    <Input
                      type="select"
                      value={selectedCategoria}
                      onChange={(e) => setSelectedCategoria(e.target.value)}
                    >
                      <option value="">Sin categoría</option>
                      {categorias
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((c) => (
                          <option value={c._id}>{c.name}</option>
                        ))}
                    </Input>
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col md={4}>
                    <Label className="mr-sm-2">Concepto</Label>
                    <Input
                      type="text"
                      value={concepto}
                      onChange={(e) => setConcepto(e.target.value)}
                    />
                  </Col>
                  <Col md={4}>
                    <Label className="mr-sm-2">Descripción</Label>
                    <Input
                      type="text"
                      value={descripcion}
                      onChange={(e) => setDescripcion(e.target.value)}
                    />
                  </Col>
                  <Col md={4}>
                    <Label className="mr-sm-2">
                      Proveedor <small className="text-muted">(opcional)</small>
                    </Label>
                    <Input
                      type="select"
                      value={selectedProveedor}
                      onChange={(e) => setSelectedProveedor(e.target.value)}
                    >
                      <option value="">Ninguno</option>
                      {proveedores
                        .sort((a, b) =>
                          (a.nombre_comercial || "") > (b.nombre_comercial || "")
                            ? 1
                            : -1
                        )
                        .map((p) => (
                          <option value={p._id}>
                            {p.codigo} - {p.nombre_comercial}
                          </option>
                        ))}
                    </Input>
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col md={12}>
                    <Label className="mr-sm-2">Notas</Label>
                    <Input
                      type="text"
                      value={notas}
                      onChange={(e) => setNotas(e.target.value)}
                    />
                  </Col>
                </Row>
              </>
            )}

            <Row className="mt-3">
              <Col>
                {validaBoton ? (
                  <Button type="submit" className="btn btn-success">
                    Registrar
                  </Button>
                ) : (
                  <Button type="submit" className="btn btn-success" disabled>
                    Registrar
                  </Button>
                )}{" "}
                <Button className="btn btn-danger" href="/MovimientosBancos">
                  Regresar
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      ) : undefined}
    </>
  );
}

export default MovimientosBancosCreate;
